import React from "react";
import NotFoundImage from "../NewDesign/NotFound/NotFoundImage";
function ErrorSectionSidebar() {
  return (
    <section className="esbar mt-5 text-center">
     <NotFoundImage width={200} height={219} />
      {/* <div className="error-msgs">Nothing here, yet.</div>
      <div className="button-design">
        <button type="button" className="startcourse-btn">
          Explore courses
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
              stroke="#415385"
              strokeWidth="1.66667"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
        </button>
      </div> */}
    </section>
  );
}

export default ErrorSectionSidebar;
